import { FeatureFlag, FeatureFlagState } from 'marketing-site/lib/featureFlags'
import FeatureFlagStateContext from 'marketing-site/src/components/context/FeatureFlagStateContext'
import { useContext } from 'react'

export function useFeatureFlagState(featureFlagId: FeatureFlag): FeatureFlagState {
  const featureFlags = useContext(FeatureFlagStateContext)

  if (!featureFlags || !Object.keys(featureFlags).includes(featureFlagId)) {
    return FeatureFlagState.Unknown
  }

  const isEnabled = featureFlags[featureFlagId]
  return isEnabled ? FeatureFlagState.Enabled : FeatureFlagState.Disabled
}
